import { createAction } from 'redux-actions';
import API from '../../../../utils/api';

export const fetchTeamsList = createAction(
  '@@imageLibrary/fetchTeamsList',
  leagueId => dispatch => {
    let query = { leagues: leagueId };
    query = JSON.stringify(query);
    return API.getTeams({ query, ignoreDependencies: true }).then(({ data }) => {
      return data.docs;
    });
  }
);

export const fetchLeagueList = createAction(
  '@@imageLibrary/fetchLeagueList',
  () => dispatch => {
    return API.getLeagues({ ignoreDependencies: true }).then(({ data }) => {
      if (data && data.docs) {
        return data.docs;
      }
      return [];
    });
  }
);

export const clearTeamsList = createAction('@@imageLibrary/clearTeamsList');

export const changeUpdateN = createAction('@@imageLibrary/changeUpdateN');
